import React, { useContext } from 'react';
import { BodyMedium, H3 } from '@styled';
import { MembershipContext } from '../../../../context/MembershipProvider';
import { LoadingContext } from '@context/LoadingProvider';
import { insertMember } from '@general/api/memberAPI';
import NewPassword from '../../../_molecules/NewPassword';
import { PasswordChangeContext } from '@context/PasswordChangeProvider';

const MembershipNoMatches = () => {
    const { matchResultsByName, user } = useContext(MembershipContext);
    const { setIsLoading } = useContext(LoadingContext);

    const { newPassword, confirmPassword, setNewPasswordError } = useContext(PasswordChangeContext);

    const createAccount = async () => {
        setIsLoading(true);
        if (newPassword !== confirmPassword) {
            setNewPasswordError('Passwords do not match');
            setIsLoading(false);
            return;
        }
        try {
            const memberResponse = await insertMember(
                {
                    first_name: matchResultsByName?.first_name,
                    last_name: matchResultsByName?.last_name,
                    email: user?.username,
                    password: newPassword,
                },
                false
            );

            if (memberResponse?.error === 'invalid password') {
                setNewPasswordError(
                    [memberResponse.message.warning, memberResponse.message.suggestions.join(' ')].join(' ')
                );
                setIsLoading(false);
            } else {
                window.location.reload();
            }
        } catch (error) {
            setIsLoading(false);
            if (error.response.data.data.error_type === 'breached_password') {
                setNewPasswordError(
                    'The password you have chosen is not considered secure. Please choose a different password.'
                );
            } else {
                setNewPasswordError(
                    'Please choose a different password.'
                );
            }
        }
    };

    return (
        <div>
            <H3>No matches found</H3>
            <BodyMedium className="mt-1.125rem">
                It doesn't look like you have an account. Please create a password to create an account.
            </BodyMedium>

            <div style={{ marginTop: '2rem', maxWidth: '400px', marginBottom: '6rem' }}>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
                    <NewPassword email={user?.email} onUpdate={createAccount} buttonText="Create an Account" />
                </div>
            </div>
        </div>
    );
};

MembershipNoMatches.propTypes = {
    //
};

export default MembershipNoMatches;
